import { FormikErrors, setIn } from 'formik';
import { ISettingsGroups } from './interfaces';

type Rule = (value: unknown) => string | undefined;

export const MRP_ERROR = 'Целое число больше 0';
export const RATE_ERROR = 'Число от 0 до 100, не более двух знаков после запятой';

const MAX_RATE = 100;

const toText = (value: unknown) => String(value ?? '').trim();

// Правила те же, что на бэке: МРП — целое больше 0
export const getMrpError: Rule = (value) => (/^0*[1-9]\d*$/.test(toText(value)) ? undefined : MRP_ERROR);

// Ставка — от 0 до 100, значащих знаков после точки не больше двух (16.50 можно, 16.505 нельзя)
export const getRateError: Rule = (value) => {
  const text = toText(value);
  return /^\d+(\.\d{0,2}0*)?$/.test(text) && Number(text) <= MAX_RATE ? undefined : RATE_ERROR;
};

const RULES: Record<string, Rule> = {
  MONTHLY_CALCULATION_INDICATOR: getMrpError,
  TARIFF_VAT_RATE: getRateError,
  TARIFF_MANAGEMENT_SERVICE_RATE: getRateError,
  TARIFF_MAINTENANCE_COST_SHARE: getRateError,
};

// Ошибки по путям полей: пока они есть, Formik не вызывает onSubmit
export const validateAppSettings = ({ settings }: { settings: ISettingsGroups }) => {
  let errors: FormikErrors<{ settings: ISettingsGroups }> = {};

  settings.forEach((group, groupIndex) => {
    (group.settings as { key: string; value: unknown }[]).forEach(({ key, value }, index) => {
      const error = RULES[key]?.(value);
      if (error) errors = setIn(errors, `settings[${groupIndex}].settings[${index}].value`, error);
    });
  });

  return errors;
};
